import type { LatLon } from './types';

// User-facing hardcoded city list for the Telegram MVP. City IDs are normally
// resolved through /get-points-country-data, but Telegram/browser CORS can block
// that RPC host, so every supported city keeps an authoritative fallback.
export type SupportedCity = LatLon & {
  id: string;
  name: string;
  cityIdFallback?: string;
};

export const SUPPORTED_CITIES: SupportedCity[] = [
  {
    id: 'kryvyi-rih',
    name: 'Кривий Ріг',
    lat: 47.9097,
    lon: 33.3804,
    cityIdFallback: '5a3c4329-7da3-4431-aaaa-4c4462b435d0',
  },
  {
    id: 'kharkiv',
    name: 'Харків',
    lat: 49.9935,
    lon: 36.2304,
    cityIdFallback: 'be427f49-844b-469b-a8fc-65eed9ae5479',
  },
  {
    id: 'dnipro',
    name: 'Дніпро',
    lat: 48.4647,
    lon: 35.0462,
    cityIdFallback: 'cacf983e-a1e0-4906-aae2-18214e5f5a71',
  },
  {
    id: 'zaporizhzhia',
    name: 'Запоріжжя',
    lat: 47.8388,
    lon: 35.1396,
    cityIdFallback: 'fe86887d-0a16-4f27-9bcf-c1d24875e876',
  },
];

const CITY_STORAGE_KEY = 'selected_city_id';

export function getStoredCity(): SupportedCity | null {
  const id = localStorage.getItem(CITY_STORAGE_KEY);
  return SUPPORTED_CITIES.find((city) => city.id === id) ?? null;
}

export function saveStoredCity(city: SupportedCity): void {
  localStorage.setItem(CITY_STORAGE_KEY, city.id);
}

export function clearStoredCity(): void {
  localStorage.removeItem(CITY_STORAGE_KEY);
}
